// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_375234cf","tagName":"_8ffb6949","categoryCreator":"_690b85d0","searchLink":"_41e1392"};